import { createContext, MutableRefObject, useContext, useRef, useState } from 'react';
import { DrawEvent } from 'd3-draw';

import { FieldPiece, FrameSnapshot } from '@labradorsports/play-rendering';

import { usePen, usePieceDrag, usePieceDrop, useArrowKeys, useZoom } from '../hooks/index.js';

export interface InteractionLayerValue {
    activeStroke?: DrawEvent<Element, null>[];
    simplifiedStroke?: DrawEvent<Element, null>[][];
    drop: AnyFunction;
    tempFrames?: FrameSnapshot[];
    dragAdjustmentRef: MutableRefObject<any>;
    /** Pieces currently being manipulated (e.g. dragged) or hovered (e.g. drop preview); set whenever tempFrames is set */
    manipulatingPieces: FieldPiece[];
}

export const InteractionLayerContext = createContext<InteractionLayerValue>(null);

export const useInteractionLayer = (): InteractionLayerValue => {
    return useContext(InteractionLayerContext);
};

export const InteractionLayerProvider: FC = ({ children }) => {
    const dragSubjectRef = useRef<any>();
    const [tempFrames, setTempFrames] = useState(null);
    const [manipulatingPieces, setManipulatingPieces] = useState<FieldPiece[]>([]);
    const { activeStroke, simplifiedStroke } = usePen();
    const { drop } = usePieceDrop({ setTempFrames, setManipulatingPieces });
    const { dragAdjustmentRef } = usePieceDrag({ setTempFrames, setManipulatingPieces, dragSubjectRef });
    useZoom({ dragSubjectRef });
    useArrowKeys();

    return (
        <InteractionLayerContext.Provider
            value={{
                activeStroke,
                simplifiedStroke,
                drop,
                tempFrames,
                dragAdjustmentRef,
                manipulatingPieces,
            }}
        >
            {children}
        </InteractionLayerContext.Provider>
    );
};
